const OrganogramaSchema = () => ({
  title: 'AgSUS Organograma',
  fieldsets: [{ id: 'default', title: 'Geral', fields: ['title'] }],
  properties: {
    title: {
      title: 'Título',
      description:
        'Opcional. Conteúdo do organograma é fixo no add-on; para mudar a estrutura, abra um pull request em volto-agsus.',
      default: 'Organograma da AgSUS',
    },
  },
  required: [],
});

export default OrganogramaSchema;
